"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScreenshareAudio = void 0;
var _react = require("react");
var _reactSdk = require("@100mslive/react-sdk");
var useScreenshareAudio = function useScreenshareAudio() {
  var hmsActions = (0, _reactSdk.useHMSActions)();
  var peer = (0, _reactSdk.useHMSStore)(_reactSdk.selectPeerSharingAudio);
  var track = (0, _reactSdk.useHMSStore)((0, _reactSdk.selectScreenShareAudioByPeerID)(peer === null || peer === void 0 ? void 0 : peer.id));
  var handleMute = (0, _react.useCallback)(function () {
    if (!peer.isLocal) {
      hmsActions.setVolume(!track.volume ? 100 : 0, track.id);
    } else {
      hmsActions.setEnabledTrack(track.id, !track.enabled)["catch"](console.error);
    }
  }, [peer, hmsActions, track]);
  var muted = undefined;
  if (peer && track) {
    muted = peer.isLocal ? !track.enabled : track.volume === 0;
  }
  return {
    peer: peer,
    track: track,
    muted: muted,
    onToggle: handleMute
  };
};
exports.useScreenshareAudio = useScreenshareAudio;